import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { DonkeyMark } from "@/components/Logo";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-donkey-bg">
        <DonkeyMark size={48} className="animate-pulse-soft" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
